import styled from 'styled-components';

export const ContactContainer = styled.div``;

export const Hero = styled.section`
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url('/images/contact-hero.jpg') center/cover no-repeat;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;

  h1 {
    font-size: 3rem;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.2rem;
  }
`;

export const ContactSection = styled.section`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 4rem;
  padding: 80px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

export const ContactInfo = styled.div`
  h2 {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  > p {
    color: ${({ theme }) => theme.colors.text};
    margin-bottom: 2rem;
  }

  .info-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 2rem;

    svg {
      color: ${({ theme }) => theme.colors.primary};
      font-size: 1.5rem;
      margin-right: 1rem;
      margin-top: 0.5rem;
    }

    h3 {
      color: ${({ theme }) => theme.colors.text};
      margin-bottom: 0.5rem;
    }

    p {
      color: ${({ theme }) => theme.colors.lightText};
      line-height: 1.6;
    }
  }
`;

export const ContactForm = styled.form`
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  h2 {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 2rem;
    margin-bottom: 2rem;
  }

  .form-group {
    margin-bottom: 1.5rem;

    label {
      display: block;
      margin-bottom: 0.5rem;
      color: ${({ theme }) => theme.colors.text};
    }

    input,
    textarea {
      width: 100%;
      padding: 0.8rem;
      border: 1px solid #ddd;
      border-radius: 5px;
      font-size: 1rem;

      &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primary};
      }
    }
  }
`;